const UserConstants = {
  UPDATE: 'UPDATE_USERS',
  RESET: 'RESET_USERS',
}

export {UserConstants}
